import { defineFcm } from '../shared/factory';

export const FCM_SPH_MOBILE_IMPACT_FIRST_ENABLED = defineFcm('sph_mobile_impact_first_enabled')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-vaquita',
		scope: 'corgi-front-end',
		context: 'Supporter → DM Outreach',
		description:
			'Enables the sph_mobile_impact_first experiment (CHANGE-101254): on mobile Signed Petition Home, renders the ' +
			'Impact + Checklist block directly under the petition card, above the updates feed, with the sticky section ' +
			'tabs reordered to match. Desktop is unchanged. The experiment is also limited to the en-US locale in its ' +
			'config. Off, every viewer sees the current order.',
	});
